export default __webpack_public_path__ + "static/media/girlWithAMandolin.5203204f.jpg";